import { NavLink, Outlet } from 'react-router-dom';
import AppHeader from '../../components/layout/AppHeader.jsx';

const NAV = [
  { to: '/revrec/contracts', label: 'Contracts', testid: 'revrec-nav-contracts' },
  { to: '/revrec/obligations', label: 'Obligations', testid: 'revrec-nav-obligations' },
  { to: '/revrec/schedules', label: 'Schedules', testid: 'revrec-nav-schedules' },
];

export default function RevRecShell() {
  return (
    <div className="hr-shell" data-testid="revrec-shell">
      <AppHeader />
      <div className="hr-body">
        <aside className="hr-side">
          <div className="hr-side-title">Revenue Recognition</div>
          <ul>
            {NAV.map((n) => (
              <li key={n.to}>
                <NavLink to={n.to} data-testid={n.testid} className={({ isActive }) => (isActive ? 'active' : '')}>
                  {n.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </aside>
        <main className="hr-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
